// alertUtility.js
export function showAlert(message) {
  const alertBox = document.createElement("div");

  // Set the HTML content
  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="alert-message ftw-4 common-text">${message}</span>
      </div>
    `;

  // Style the alert container
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  alertBox.style.border = "1px solid rgba(255, 0, 0, 0.20)";
  alertBox.style.boxShadow = "0px 8px 15px 0px rgba(255, 0, 0, 0.20)";
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  // alertBox.style.maxWidth = '480px';
  // alertBox.style.width = '90%';
  alertBox.style.boxSizing = "border-box";
  alertBox.style.zIndex = "999999";
  alertBox.style.animation = "slideDown 0.3s ease-out forwards";

  // Add animation keyframes
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      .alert-message {
        font-size: 0.875rem;
      }
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
      
    `;
  document.head.appendChild(styleSheet);

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Add the alert-box class to the alertBox element
  alertBox.classList.add("alert-box");

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Remove the alert after 3 seconds
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      if (document.body.contains(alertBox)) {
        document.body.removeChild(alertBox);
      }
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    }, 300);
  }, 3000);
}

export const errorAlert = showAlert;

let currentSessionPopup = null;

export function closeSessionTerminatedPopup() {
  if (currentSessionPopup && document.body.contains(currentSessionPopup)) {
    currentSessionPopup.style.opacity = "0";
    currentSessionPopup.style.transition = "opacity 0.2s ease";
    setTimeout(() => {
      if (currentSessionPopup && document.body.contains(currentSessionPopup)) {
        document.body.removeChild(currentSessionPopup);
      }
      currentSessionPopup = null;
    }, 200);
  }
}

export function showSessionTerminatedPopup({
  title = "Logged Out",
  message = "You have been logged out because your account was logged in on another device.",
  buttonText = "Login Now",
  onConfirm,
} = {}) {
  // If an existing popup overlay is present, remove it first
  if (currentSessionPopup && document.body.contains(currentSessionPopup)) {
    document.body.removeChild(currentSessionPopup);
    currentSessionPopup = null;
  }

  const overlay = document.createElement("div");
  overlay.className = "popup-overlay session-terminated-overlay";
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
    animation: sessionFadeIn 0.2s ease;
  `;

  overlay.innerHTML = `
    <style>
      @keyframes sessionFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes sessionSlideUp {
        from { opacity: 0; transform: translateY(20px) scale(0.96); }
        to { opacity: 1; transform: translateY(0) scale(1); }
      }
      .session-popup-card {
        padding: 2rem 2rem 1.75rem 2rem;
        width: 100%;
        max-width: 440px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;
        border-radius: 1rem;
        background: #FFFFFF;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
        animation: sessionSlideUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-sizing: border-box;
        text-align: center;
        font-family: 'Poppins', sans-serif;
      }
      .session-popup-icon-circle {
        display: flex;
        width: 4rem;
        height: 4rem;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #EFF6FF;
        margin-bottom: 0.25rem;
      }
      .session-popup-title {
        color: #E03B3F;
        font-family: 'Poppins', sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.5;
        margin: 0;
      }
      .session-popup-msg {
        color: #6D6D6D;
        font-family: 'Poppins', sans-serif;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        margin: 0;
      }
      .session-popup-btn {
        background: #094C80;
        color: #FFFFFF;
        font-family: 'Poppins', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        border-radius: 0.625rem;
        padding: 0.625rem 2rem;
        border: none;
        cursor: pointer;
        margin-top: 0.5rem;
        transition: background 0.2s ease;
      }
      .session-popup-btn:hover {
        background: #073B64;
      }
    </style>
    <div class="session-popup-card">
      <div class="session-popup-icon-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 27" fill="none">
          <path d="M19.2001 2.41931L29.2516 19.1609C30.6961 21.5655 29.9866 24.729 27.6661 26.226C26.8877 26.7313 25.9796 27.0002 25.0516 27H4.94701C2.21551 27 0 24.705 0 21.8715C0 20.913 0.259501 19.9754 0.747002 19.1609L10.8 2.41931C12.243 0.0147877 15.294 -0.721718 17.6145 0.775294C18.2566 1.1893 18.7996 1.7518 19.2001 2.41931ZM15 21C15.3979 21 15.7794 20.8419 16.0607 20.5606C16.342 20.2793 16.5 19.8978 16.5 19.4999C16.5 19.1021 16.342 18.7206 16.0607 18.4393C15.7794 18.158 15.3979 17.9999 15 17.9999C14.6022 17.9999 14.2207 18.158 13.9394 18.4393C13.6581 18.7206 13.5 19.1021 13.5 19.4999C13.5 19.8978 13.6581 20.2793 13.9394 20.5606C14.2207 20.8419 14.6022 21 15 21ZM15 7.49985C14.6022 7.49985 14.2207 7.65788 13.9394 7.93919C13.6581 8.2205 13.5 8.60203 13.5 8.99986V14.9999C13.5 15.3977 13.6581 15.7793 13.9394 16.0606C14.2207 16.3419 14.6022 16.4999 15 16.4999C15.3979 16.4999 15.7794 16.3419 16.0607 16.0606C16.342 15.7793 16.5 15.3977 16.5 14.9999V8.99986C16.5 8.60203 16.342 8.2205 16.0607 7.93919C15.7794 7.65788 15.3979 7.49985 15 7.49985Z" fill="#E03B3F"/>
        </svg>
      </div>
      <h3 class="session-popup-title">${title}</h3>
      <p class="session-popup-msg">${message}</p>
      <button class="session-popup-btn" type="button">${buttonText}</button>
    </div>
  `;

  const btn = overlay.querySelector(".session-popup-btn");
  if (btn) {
    btn.addEventListener("click", () => {
      closeSessionTerminatedPopup();
      if (typeof onConfirm === "function") {
        onConfirm();
      }
    });
  }

  document.body.appendChild(overlay);
  currentSessionPopup = overlay;

  return overlay;
}
